/**
 * WidgetEmailLoginPage — landing for the widget login link
 * (/api/widget-handoff/{id}/email). It never calls the backend: it hands the
 * link to the Carmen widget on this computer via carmen://, and the widget
 * finishes the login itself.
 */

import { useMemo, useState } from "react";
import { widgetDeepLink } from "./widgetEmailLoginLink";

const PANEL_CLASS =
  "rounded-[32px] border border-[rgba(10,52,96,0.10)] bg-white/92 p-8 shadow-[0_24px_64px_rgba(10,52,96,0.10)] backdrop-blur-xl sm:p-10";
const PRIMARY_BUTTON_CLASS =
  "block w-full rounded-full bg-[var(--cs-title-navy)] px-5 py-3.5 text-center text-[15px] font-semibold text-white shadow-[0_16px_34px_rgba(10,52,96,0.18)] transition-colors duration-200 hover:bg-[var(--cs-title-navy)]";

export function WidgetEmailLoginPage() {
  const deepLink = useMemo(() => widgetDeepLink(window.location.hash), []);
  const [opened, setOpened] = useState(false);

  return (
    <div className="cs-marketing min-h-screen bg-[linear-gradient(180deg,#fcfbf7_0%,#ffffff_22%,#f3f9fd_100%)] px-4 py-12 sm:px-6 sm:py-16">
      <div className="mx-auto w-full max-w-md space-y-6">
        <div className={PANEL_CLASS}>
          <div className="mb-6 text-center">
            <h1 className="text-[32px] font-semibold tracking-[-0.04em] text-[var(--cs-title-navy)]">
              Inloggen in de widget
            </h1>
          </div>

          {deepLink ? (
            <>
              <p className="mb-6 text-center text-[15px] text-[rgba(95,131,160,0.96)]">
                Klik op de knop om in te loggen in de Carmen-widget op deze computer. Vraagt
                de browser of Carmen mag openen, kies dan <strong>Openen</strong>.
              </p>
              <a href={deepLink} onClick={() => setOpened(true)} className={PRIMARY_BUTTON_CLASS}>
                Open de Carmen-widget
              </a>
              {opened ? (
                <p className="mt-5 text-center text-[13px] text-[rgba(95,131,160,0.96)]">
                  De widget logt nu in. U kunt dit venster sluiten. Gebeurt er niets? Controleer
                  dat de widget op deze computer openstaat en dat u de link binnen 10 minuten
                  gebruikt.
                </p>
              ) : null}
            </>
          ) : (
            <div className="rounded-[18px] border border-[#F3C7CD] bg-[#FFF4F6] p-4 text-sm text-[#B42318]">
              Deze link is onvolledig. Open de knop uit de e-mail opnieuw, of vraag in de widget
              een nieuwe inloglink aan.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
